import { render, staticRenderFns } from "./OPart.vue?vue&type=template&id=25af76f2&"
import script from "./OPart.vue?vue&type=script&setup=true&lang=js&"
export * from "./OPart.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OPart.vue?vue&type=style&index=0&id=25af76f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports